import React, { ReactNode } from "react"
import useWindowSize from "hooks/useWindowSize"

interface ContentSectionProps {
    children: ReactNode
    className?: string
}

const ContentSection: React.FC<ContentSectionProps> = ({
    children,
    className,
}) => {
    const { isDesktop } = useWindowSize()

    return (
        <div
            className={`w-full rounded-xl  ${isDesktop ? "h-full" : ""} ${className}`}
        >
            {children}
        </div>
    )
}

export default ContentSection
